import CenteredHeader from "./../../Molecules/CenteredHeader/CenteredHeader";
import IndustryImageTextSection from "./../../Molecules/IndustryImageTextSection/IndustryImageTextSection";
import IndustryLightBlueSection from "./../../Organisms/IndustryLightBlueSection/IndustryLightBlueSection";
import IndustryBannerBgSection from "./../../Atoms/IndustryBannerBgSection/IndustryBannerBgSection";
import RegularIconText from "./../../Atoms/RegularIconText/RegularIconText";
import G_EVOLUTION from "../../../assets/img/G_EVOLUTION.png";
import TIEMPO_REAL_ICON from "../../../assets/img/TIEMPO_REAL_ICON.svg";
import ANALISIS_PRECISO_ICON from "../../../assets/img/ANALISIS_PRECISO_ICON.svg";
import TODO_EN_UNO_ICON from "../../../assets/img/TODO_EN_UNO_ICON.svg";
import FACIL_DE_USAR_ICON from "../../../assets/img/FACIL_DE_USAR_ICON.svg";
import EFICIENCIA_ICON from "../../../assets/img/EFICIENCIA_ICON.svg";
import FLEXIBILIDAD_ICON from "../../../assets/img/FLEXIBILIDAD_ICON.svg";
import FUNCIONALIDADES_TOP_ICON from "../../../assets/img/FUNCIONALIDADES_TOP_ICON.svg";
import G_EVOLUTION_CARACTERISTICAS_ILUSTRACION from "../../../assets/img/G_EVOLUTION_CARACTERISTICAS_ILUSTRACION.png";
import IndustryTwoButtonsSection from "./../../Atoms/IndustryTwoButtonsSection/IndustryTwoButtonsSection";
import FormShell from "../../Organisms/FormShell/FormShell";
import DynamicFormik from "./../../Organisms/DynamicFormik/DynamicFormik";
import "./SolutionsG_Evolution.scss";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import content from "./content.js";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

const SolutionsG_Evolution = () => {
	const { language } = useLanguageCtx();
	const { dropdownHeader } = useScrollCtx();

	return (
		<>
			<ChangeableHeaderV2 
				withTitle 
				gEvolution 
				appearSecondNavbar={dropdownHeader} 
				route="g-evolution" 
			/>

			<div className="top-space-section">
				<CenteredHeader
					yellowText="G-EVOLUTION"
					boldText={content[language].g_evolution_bold_title}
				/>
			</div>

			<div className="top-space-section">
				<IndustryImageTextSection
					image={{ img: G_EVOLUTION, alt: "G-Evolution App" }}
					boldText={content[language].g_evolution_bold_text}
					paragraphs={content[language].g_evolution_paragraphs}
				/>
			</div>

			<div className="top-space-section">
				<IndustryLightBlueSection
					checkText={content[language].caracteristicas_gevolution}
					yellowText={content[language].caracteristicas_gevolution_yellow_title}
					boldText={content[language].caracteristicas_gevolution_bold_title}
				/>
			</div>

			<IndustryBannerBgSection route="g-evolution">
				<div className="max-width all-height flex center-cross-axis space-around wrap">
					<div className="solutionsG_Evolution--regular_icon-container">
						<RegularIconText
							width="100%"
							whiteText
							icon={TIEMPO_REAL_ICON}
							boldText={
								content[language].caracteristica_banner_section_1.boldText
							}
							text={content[language].caracteristica_banner_section_1.text}
						/>
					</div>
					<div className="solutionsG_Evolution--regular_icon-container">
						<RegularIconText
							width="100%"
							whiteText
							icon={FLEXIBILIDAD_ICON}
							boldText={
								content[language].caracteristica_banner_section_2.boldText
							}
							text={content[language].caracteristica_banner_section_2.text}
						/>
					</div>
					<div className="solutionsG_Evolution--regular_icon-container">
						<RegularIconText
							width="100%"
							whiteText
							icon={EFICIENCIA_ICON}
							boldText={
								content[language].caracteristica_banner_section_3.boldText
							}
							text={content[language].caracteristica_banner_section_3.text}
						/>
					</div>
					<div className="solutionsG_Evolution--regular_icon-container">
						<RegularIconText
							width="100%"
							whiteText
							icon={ANALISIS_PRECISO_ICON}
							boldText={
								content[language].caracteristica_banner_section_4.boldText
							}
							text={content[language].caracteristica_banner_section_4.text}
						/>
					</div>
					<div className="solutionsG_Evolution--regular_icon-container">
						<RegularIconText
							width="100%"
							whiteText
							icon={FACIL_DE_USAR_ICON}
							boldText={
								content[language].caracteristica_banner_section_5.boldText
							}
							text={content[language].caracteristica_banner_section_5.text}
						/>
					</div>
					<div className="solutionsG_Evolution--regular_icon-container">
						<RegularIconText
							width="100%"
							whiteText
							icon={TODO_EN_UNO_ICON}
							boldText={
								content[language].caracteristica_banner_section_6.boldText
							}
							text={content[language].caracteristica_banner_section_6.text}
						/>
					</div>
				</div>
			</IndustryBannerBgSection>

			<IndustryTwoButtonsSection />

			<div className="top-space-section">
				<IndustryImageTextSection
					switchOrder
					image={{
						img: G_EVOLUTION_CARACTERISTICAS_ILUSTRACION,
						alt: "G_EVOLUTION_CARACTERISTICAS_ILUSTRACION",
					}}
					yellowText={content[language].caracteristicas_yellow_title}
					boldText={content[language].caracteristicas_bold_title}
					paragraphs={content[language].caracteristicas_paragraphs}
					checkText={content[language].caracteristicas_checkText}
				/>
			</div>

			<img
				alt="Funcionalidades Icon"
				src={FUNCIONALIDADES_TOP_ICON}
				className="center top-space-section"
			/>

			<IndustryLightBlueSection
				whiteBg
				yellowText={content[language].funcionalidades_yellow_title}
				boldText={content[language].funcionalidades_bold_title}
				checkText={content[language].funcionalidades}
			/>

			<FormShell contact title={content[language].form_title} g_evolution>
				<DynamicFormik
					buttonContent={content[language].form_button_text}
					field_1={content[language].form_fields[0]}
					field_2={content[language].form_fields[1]}
					field_3={content[language].form_fields[2]}
					field_4={content[language].form_fields[3]}
					field_5={content[language].form_fields[4]}
					field_6={content[language].form_fields[5]}
					field_7={content[language].form_fields[6]}
				/>
			</FormShell>
		</>
	);
};

export default SolutionsG_Evolution;
